const USGS = () => {
  const FlowProportions = new Pie({
    container: '#flow-pie-chart',
    widthScale: 1,
    heightScale: 1,
    innerRadius: 80,
    color: d3.scaleOrdinal(['rgb(55, 126, 184)', 'rgb(228, 26, 28)']),
    resultField: 'rvalue',
    categoryField: 'location',
    data: [
      { location: 'Cherry Creek', rvalue: 82.6 },
      { location: 'Cottonwood Creek', rvalue: 17.4 },
    ],
  }).draw();
};
